export default "__VITE_ASSET__fFB32nA3__"